import get from 'lodash/get'
import {
  FETCH_SMS_LONG_CODE_REQUEST,
  FETCH_SMS_LONG_CODE_SUCCESS,
  FETCH_SMS_LONG_CODE_FAILURE
} from './actionTypes'

import { getClientSmsLongCode as fetchSmsLongCode } from 'src/api/mikasa/requests'

export const getSmsLongCode = clientId => async dispatch => {
  dispatch({
    type: FETCH_SMS_LONG_CODE_REQUEST
  })

  try {
    const response = await fetchSmsLongCode(clientId)
    const longCode = get(
      response,
      ['data', 'data', 0, 'properties', 'sentFrom'],
      null
    )

    dispatch({
      type: FETCH_SMS_LONG_CODE_SUCCESS,
      data: longCode
    })
  } catch (error) {
    dispatch({
      type: FETCH_SMS_LONG_CODE_FAILURE,
      error
    })
  }
}
